import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Box,
  Divider,
} from "@mui/material";

// We pass 'blacklistedKeys' to hide things like "id" or "createdAt"
const DataFormCard = ({
  initialData,
  onSave,
  onCancel,
  isCreate = false,
  blacklistedKeys = ["id", "_id", "uuid", "__v"],
}) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    // If creating, start empty. If editing, sync with selectedRow.
    setFormData(initialData || {});
  }, [initialData]);

  // Handle input changes dynamically
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Generate fields based on the keys of the object
  // If we are creating and initialData is null, we use the keys from the first row of your grid
  const fieldKeys = Object.keys(formData).filter(
    (key) => !blacklistedKeys.includes(key),
  );

  return (
    <Card variant="outlined" sx={{ mt: 2, borderRadius: 2, boxShadow: 3 }}>
      <Box
        sx={{
          p: 2,
          bgcolor: isCreate ? "success.dark" : "primary.dark",
          color: "white",
        }}
      >
        <Typography variant="h6">
          {isCreate ? "Add New Record" : "Edit Record"}
        </Typography>
      </Box>
      <Divider />
      <CardContent>
        <Grid container spacing={2}>
          {fieldKeys.map((key) => (
            <Grid item xs={12} sm={6} key={key}>
              <TextField
                fullWidth
                // Format the label: "firstName" -> "First Name"
                label={key
                  .replace(/([A-Z])/g, " $1")
                  .replace(/_/g, " ")
                  .toUpperCase()}
                name={key}
                value={formData[key] || ""}
                onChange={handleChange}
                variant="outlined"
                size="small"
              />
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button onClick={onCancel} color="inherit" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={() => onSave(formData)}
            variant="contained"
            color={isCreate ? "success" : "primary"}
          >
            {isCreate ? "Submit" : "Update"}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DataFormCard;
